const getQueryString = (name) => {
  let urls = window.location.href;
  let url = urls.replace('%0A',"")
  let params = url.substring(url.indexOf("?"));
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = params.substr(1).match(reg);
  if (r != null) {
    return decodeURI(r[2]);
  }
  return null;
};
export default getQueryString;
